import nbdecimal from './input.nbdecimal.directive';

export default {
    nbdecimal
};
